// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var AccountContactInformationPurposeType;
(function (AccountContactInformationPurposeType) {
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["UNKNOWN"] = 0] = "UNKNOWN";
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["MAIN"] = 1] = "MAIN";
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["MARKETING"] = 2] = "MARKETING";
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["SALES"] = 3] = "SALES";
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["CUSTOMERSERVICE"] = 4] = "CUSTOMERSERVICE";
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["HOME"] = 5] = "HOME";
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["WORK"] = 6] = "WORK";
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["SEASONAL"] = 7] = "SEASONAL";
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["OTHER"] = 8] = "OTHER";
})(AccountContactInformationPurposeType || (AccountContactInformationPurposeType = {}));
//# sourceMappingURL=accountContactInformationPurposeType.js.map